import { render, staticRenderFns } from "./feedBackList.vue?vue&type=template&id=6d6dc16f&scoped=true&"
import script from "./feedBackList.vue?vue&type=script&lang=js&"
export * from "./feedBackList.vue?vue&type=script&lang=js&"
import style0 from "./feedBackList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./feedBackList.vue?vue&type=style&index=1&id=6d6dc16f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6dc16f",
  null
  
)

export default component.exports